import cn from "@utils/helpers/cn";
import sx from "@utils/helpers/sx";
import Card from "@elements/Card";

const CARD_CLASS_NAMES = cn(`
  max-w-2xl
  rounded-xl
  border-2
  border-t-1.5
  border-b-4
  px-8
  py-0
  text-center
  text-sm
  md:text-base
  leading-relaxed
  tracking-wide

  bg-[#FAF7F5]
  border-[#C9A045]
  text-[#7C6234]
`);

const CARD_STYLES = sx({
  boxShadow: "0 2px 8px 0 #C9A04520, 0 6px 16px -2px #6B4C1415",
});

const CORNER_DOT_CLASS_NAMES = cn(`
  absolute
  size-1.5
  rounded-full

  bg-[#C9A045]
`);

const CORNER_DOT_STYLES = sx({
  boxShadow: "0 0 2px 1px #C9A04566",
});

const CornerDot = (props) => (
  <span
    className={cn(CORNER_DOT_CLASS_NAMES, props.className)}
    style={CORNER_DOT_STYLES}
  />
);

const CornerDots = () => (
  <>
    <CornerDot className="top-2.5 left-2.5" />
    <CornerDot className="top-2.5 right-2.5" />
    <CornerDot className="bottom-2.5 left-2.5" />
    <CornerDot className="bottom-2.5 right-2.5" />
  </>
);

export default function InstructionCard(props) {
  const {
    className,
    content,
  } = props;

  /**************************************************************************************************/

  if (!content) return null;

  const classNames = cn(CARD_CLASS_NAMES, className);

  return (
    <div className="flex items-center justify-center">
      <Card
        className={classNames}
        style={CARD_STYLES}
        contentClassName="flex flex-col gap-4"
      >
        <CornerDots />

        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Card>
    </div>
  );
}
